module.exports = __webpack_public_path__ + "static/media/image-rules-bonus.bab8b554.svg";